import React from "react";
import Header from "@/components/Header";
import ExpensesCard from "@/components/ExpensesCard";
import { usePeriod } from "@/contexts/PeriodContext";

export default function ExpensesPage() {
  const { month, year, view, setMonth, setYear, setView, refreshKey, bump } = usePeriod();
  return (
    <div className="min-h-screen">
      <Header
        month={month}
        year={year}
        view={view}
        setMonth={setMonth}
        setYear={setYear}
        setView={setView}
        title="ניהול הוצאות"
        backTo="/app"
      />
      <main className="max-w-6xl mx-auto px-4 md:px-8 py-8">
        <ExpensesCard
          month={month}
          year={year}
          refreshKey={refreshKey}
          onChange={bump}
          startOpen={true}
        />
      </main>
    </div>
  );
}
